var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOutClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_1181",
    "data-name": "\\u7EC4 1181",
    transform: "translate(-857 -970)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "zoom-out",
    transform: "translate(857 970)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_33",
    "data-name": "\\u692D\\u5706 33",
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#226fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_34",
    "data-name": "\\u692D\\u5706 34",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(2 2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_1179",
    "data-name": "\\u7EC4 1179"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_35",
    "data-name": "\\u692D\\u5706 35",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(11 11)",
    strokeWidth: 1.5,
    stroke: "#226fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u76F4\\u7EBF_33",
    "data-name": "\\u76F4\\u7EBF 33",
    x2: 3,
    y2: 3,
    transform: "translate(23 23)",
    fill: "none",
    stroke: "#226fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u76F4\\u7EBF_34",
    "data-name": "\\u76F4\\u7EBF 34",
    x2: 4,
    transform: "translate(16 18)",
    fill: "none",
    stroke: "#226fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutClick);
export default __webpack_public_path__ + "static/media/zoom-out-click.15f6b631d886da2da83eef13a0ca5b60.svg";
export { ForwardRef as ReactComponent };